import ReactSelect, { Props, GroupBase } from 'react-select';
import { ISelectOption, ISelectCustomProps } from '../interfaces';
import SelectLayout from '../SelectLayout';

const Select = <
  SOption extends ISelectOption = ISelectOption,
  IsMulti extends boolean = boolean,
  Group extends GroupBase<SOption> = GroupBase<SOption>,
>(selectProps: ISelectCustomProps<SOption, IsMulti, Group> & Props<SOption, IsMulti, Group>) => (
  <SelectLayout { ...selectProps } component={ ReactSelect } />
);

export default Select;
